var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStArrowRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2138_39292)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5782 6.62188L6.67512 1.49844C6.62981 1.45937 6.572 1.4375 6.51106 1.4375H5.12825C5.01262 1.4375 4.9595 1.58125 5.047 1.65625L10.5189 6.40625H1.37512C1.30637 6.40625 1.25012 6.4625 1.25012 6.53125V7.46875C1.25012 7.5375 1.30637 7.59375 1.37512 7.59375H10.5173L5.04543 12.3438C4.95793 12.4203 5.01106 12.5625 5.12669 12.5625H6.55637C6.58606 12.5625 6.61575 12.5516 6.63762 12.5313L12.5782 7.37813C12.6323 7.33109 12.6757 7.27299 12.7054 7.20776C12.7352 7.14253 12.7505 7.07168 12.7505 7C12.7505 6.92832 12.7352 6.85747 12.7054 6.79224C12.6757 6.72701 12.6323 6.66891 12.5782 6.62188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2138_39292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStArrowRightIcon);
export default __webpack_public_path__ + "static/media/st-arrow-right-icon.762e78a12b101d4afdc1649ea0c5e490.svg";
export { ForwardRef as ReactComponent };